export const adaptQuickLink = (data: IQuickLink): QuickLink => {
	return {
		id: data.id,
		heading: data.heading,
		content: data.content,
		buttonLink: data.button_link,
		appLink: data.app_link,
		modalLink: data.modal_link,
		webview: data.webview,
		published: data.published,
		order: data.order,
		createdBy: data.created_by
			? {
					id: data.created_by.id,
					firstName: data.created_by.first_name,
					lastName: data.created_by.last_name
				}
			: undefined,
		createdAt: data.created_at,
		updatedAt: data.updated_at
	};
};

export const adaptQuickLinks = (data: IQuickLink[]): QuickLink[] => {
	return data.map(adaptQuickLink);
};
